import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideLimitPeriod } from './ride-limit-period';
import { OrganizationType } from './organization-type';

@inheritSerialization(AbstractModel)
export class Organization extends AbstractModel {
  @autoserialize
  ambulatoryRideLimit: number;

  @autoserialize
  bookingPhoneNumber: string;

  @autoserialize
  clientInvoiceEstimateRequired: boolean;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  driverIdBadgeRequired: boolean;

  @autoserialize
  itineraryPartnerIdentifierAvailable: boolean;

  @autoserialize
  name: string;

  @autoserialize
  pcaEnabled: boolean;

  @autoserialize
  pcaApprovalRequired: boolean;

  @autoserializeAs(RideLimitPeriod)
  rideLimitPeriod: RideLimitPeriod;

  @autoserialize
  rideRequestPartnerIdentifierAvailable: boolean;

  @autoserialize
  riderAppEnabled: boolean;

  @autoserialize
  riderAppItineraryCreationEnabled: boolean;

  @autoserialize
  riderEligibilityPhoneNumber: string;

  @autoserialize
  riderFareCollectionEnabled: boolean;

  @autoserialize
  riderPartnerIdentifierAvailable: boolean;

  @autoserialize
  riderPaymentAccountEnabled: boolean;

  @autoserialize
  riderPaymentRequired: boolean;

  @autoserialize
  riderRideLimit: number;

  @autoserializeAs(RideLimitPeriod)
  riderRideLimitPeriod: RideLimitPeriod;

  @autoserialize
  riderSignatureCaptureEnabled: boolean;

  @autoserialize
  scheduleByDropoffOnly: boolean;

  @autoserialize
  scheduleByPickupOnly: boolean;

  @autoserialize
  wavRideLimit: number;

  @autoserialize
  preferredProviderEnabled: boolean;

  @autoserialize
  riderDateOfBirthRequired: boolean;

  @autoserialize
  rideReminderEnabled: boolean;

  @autoserialize
  delayPickUpAllowed: boolean;

  @autoserialize
  riderSelfServiceRideCancelAllowed: boolean;

  @autoserialize
  organizationType: OrganizationType;
}
